import React from "react";
import "../css/AppBody.scss";

function OurConcept(){
    return <div className="rd-xs-12 rd-grid rd-gap-1 our_concept">
        <span className="rd-xs-12 text-headline-4">Notre mission</span>
        <div className="rd-xs-4 our_concept_img">

        </div>
        <div className="rd-xs-8 mission_wrapper">
            <p className="text-headline-6 mission_text">
                En tant qu'entreprise prévoyant déployer une solution, ou démarrer une nouvelle affaire, dans un pays africain spécifique,
                vous avez besoin de réaliser une étude approfondie du terrain afin de récolter des informations économiques, sociales, démographiques,
                ou culturelles, pouvant impacter votre projet.
            </p>
            <p className="text-headline-6 mission_text">
                Notre mission dans ce sens consiste a éffectuer cette tache de collecte d'informations  vitales pour vous,
                éliminant ainsi la nécéssité de vous déplacer vous meme sur le terrain et de planifier cette quete d'informations.
            </p>
            <p className="text-headline-6 mission_text">
                Nous fonctionnons a partir d'un réseau dense de collecteurs qui ont pour mission de glaner l'information.
            </p>
            <button className="text-button procedure">Comment fonctionne la procédure ?</button>
        </div>
    </div>
}

function WhyUs(){
    return <div className="rd-xs-12 rd-grid why_us">
        <span className="rd-xs-12 text-headline-4">Pourquoi nous choisir ?</span>
        <div className="rd-xs-12 reason_list">
            <div className="reason">
                <div className="reason_img"></div>
                <div className="reason_text">
                    <span className="text-headline-5 reason_title">
                        Fiabilité des informations
                    </span>
                    <p className="rd-xs-12 text-body-2 reason_desc">
                        Nous vous fournissons des informations que vous ne trouverez <b>pas</b> sur internet.
                    </p>
                </div>
            </div>
            <div className="reason">
                <div className="reason_img"></div>
                <div className="reason_text">
                    <span className="text-headline-5 reason_title">
                        Vaste réseau de collecteurs
                    </span>
                    <p className="rd-xs-12 text-body-2 reason_desc">
                        Nous vous fournissons des informations que vous ne trouverez <b>pas</b> sur internet.
                    </p>
                </div>
            </div>
        </div>
    </div>
}

function OurSolutions(){

    return <div className="rd-xs-12 rd-grid rd-gap-4 our_solutions">
        <span className="rd-xs-12 text-headline-4">Nos Solutions</span>
        <div className="rd-xs-12 solution_list">
            <div className="solution">
                <div className="solution_img"></div>
                <div className="solution_text">
                    <span className="text-headline-6 solution_title">Collectes</span>
                    <span className="text-body-2 solution_desc">
                        Les collectes d'information 
                        permettent de rassembler des informations diverses 
                        a travers un formulaire concu selon votre requete
                    </span>
                </div>
            </div>
            <div className="solution">
                <div className="solution_img"></div>
                <div className="solution_text">
                    <span className="text-headline-6 solution_title">Sondages</span>
                    <span className="text-body-2 solution_desc">
                        Les sondages constituent une collecte d'informations 
                        ou nous proposons de multiples choix 
                        a travers un formulaire clair et concis, 
                        dans le but de collecter l'avis de personnes physiques, 
                        via notre reseau de collecteurs
                    </span>
                </div>
            </div>
            <div className="solution">
                <div className="solution_img"></div>
                <div className="solution_text">
                    <span className="text-headline-6 solution_title">Vérification d'informations</span>
                    <span className="text-body-2 solution_desc">
                        Les sondages constituent une collecte d'informations 
                        ou nous proposons de multiples choix 
                        a travers un formulaire clair et concis
                    </span>
                </div>
            </div>
        </div>
    </div>
}

function AppBody(){
    return <div className="w-100 rd-grid app_body">
        <OurConcept/>
        <OurSolutions/>
        <WhyUs/>
    </div>
}

export default AppBody;